import React from 'react';

interface PageTitleProps {
  title?: string;
  subtitle?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({
  title = 'Rota inteligente',
  subtitle = 'Sugeridas por Inteligência Artificial.'
}) => (
  <div className="margin-y-20 margin-top-0 padding-top-0 padding-left-20">
    <p className="text-size-h1 text-bold margin-0 padding-0">{title}</p>
    <p className="text-color-black text-light margin-0 padding-0 text-size-18">{subtitle}</p>
  </div>
);

export default PageTitle;